import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import moment from 'moment';
import showAlert from '../../../common/utils/alert';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';
import CustomLoader from '../../common/CustomLoader';

function GithubExportList({
  projectId,
  githubExportList,
  listGithubExportRequestPending,
  deleteGithubExportRequest,
  deleteFlag,
  version,
  isReadOnly,
}) {
  const handleDelete = ({ uuid, projectId }) => {
    const preConfirm = async () => {
      await deleteGithubExportRequest({ uuid, projectId, version });
      Swal.fire('Deleted', 'The GitHub export request has been deleted.', 'success');
    };
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  if (listGithubExportRequestPending) {
    return <CustomLoader loading={listGithubExportRequestPending} size="20px" color="#303453" />;
  }
  if (!githubExportList || githubExportList.length === 0) {
    return <div>No GitHub Export Requests Found</div>;
  }

  return (
    <table className="table table-bordered table-word-break">
      <thead>
        <tr>
          <th>Setting Name</th>
          <th>Repository Owner</th>
          <th>Repository Name</th>
          <th>Created On</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {githubExportList.map((exportItem, index) => (
          <tr key={exportItem.uuid}>
            <td>{exportItem.name}</td>
            <td>{exportItem.repoOwner}</td>
            <td>{exportItem.repoName}</td>
            <td>{moment(exportItem.createdAt).format('Do MMM YYYY hh:mm:ss A')}</td>
            <td>
              <button
                type="button"
                className="btn btn-theme-delete btn-xs"
                style={{ cursor: deleteFlag && !isReadOnly ? 'pointer' : 'not-allowed' }}
                title={isReadOnly ? 'Read-Only Mode' : 'Delete Item'}
                onClick={() =>
                  deleteFlag && !isReadOnly
                    ? handleDelete({ uuid: exportItem.uuid, projectId })
                    : undefined
                }
                disabled={isReadOnly}
              >
                <i className="wb webconnect-trash-regular" />
                &nbsp;
                {deleteFlag ? null : (
                  <TooltipInfo title={description} showHeader={true} showArrow={true} />
                )}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default GithubExportList;
